/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 08-09-2026
 *
 * De typen die door meer dan één applicatie gebruikt worden. Alles wat maar in één app voorkomt
 * hoort in die app thuis.
 */

/**
 * Een object met sleutels van het type string; de ng21-tegenhanger van de `hash` uit sihw-ngx,
 * hier herhaald zodat `dynalearn-common` ook zonder die import leesbaar blijft.
 */
export type Hash<T = any> = { [sleutel: string]: T };

/**
 * De velden die elke backoffice-sessie in zijn userdata heeft. Admin en material vullen dit elk
 * met hun eigen velden aan; de gedeelde components (footer, navbar) lezen alleen deze.
 */
export interface BasisUserdata {
    /** Het id van de ingelogde gebruiker. */
    iduser: string;
    /** De gebruikersnaam waarmee is ingelogd; bij Dynalearn een e-mailadres. */
    username: string;
    /** De naam zoals die in de interface getoond wordt. */
    displayname: string;
}

/**
 * Een fout zoals het backend die teruggeeft: een code die als vertaalsleutel dienstdoet, met een
 * leesbare boodschap ernaast. Niet elke afwijzing heeft een code — een timeout van `SpinJS` is
 * bijvoorbeeld een kale string.
 */
export interface Backendfout {
    code?: string;
    msg?: string;

    /**
     * De registratie-actie gebruikt `foutcode` in plaats van `code`; beide vormen komen voor.
     */
    foutcode?: string;
}

/**
 * De taalcodes waarin de backoffice beschikbaar is. De eerste is de terugvaltaal. Dit is ook de
 * standaardwaarde van `TALEN_TOKEN`: een applicatie die zijn talen niet zelf opgeeft, krijgt deze.
 */
export const TALEN = ['en', 'nl', 'de'] as const;

/**
 * Een taalcode in bcp47-vorm: `nl`, `de`, `pt-BR`. Welke er in een applicatie zijn, staat in
 * `TALEN_TOKEN` — create heeft er zes, de backoffice-applicaties drie, en een union van de drie zou
 * de zes uitsluiten.
 */
export type Taalcode = string;
